import { render, staticRenderFns } from "./BackgroundCheckList.vue?vue&type=template&id=37bdf856&scoped=true&lang=pug"
import script from "./BackgroundCheckList.vue?vue&type=script&lang=ts"
export * from "./BackgroundCheckList.vue?vue&type=script&lang=ts"
import style0 from "./BackgroundCheckList.vue?vue&type=style&index=0&id=37bdf856&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37bdf856",
  null
  
)

export default component.exports